'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { ReviewEntry, ReviewForm } from '@benzinga/content-manager';
import { ReviewEntryCard } from './ReviewEntryCard';

export interface ReviewEntriesProps {
  entries: ReviewEntry[];
  form?: ReviewForm;
}

export const ReviewEntries: React.FC<ReviewEntriesProps> = ({ entries, form }) => {
  const [reviewEntries, setReviewEntries] = React.useState<ReviewEntry[]>(entries);
  React.useEffect(() => {
    window.addEventListener('review_submit', (e: any) => {
      if (form?.rating_form_id === e.detail.form.rating_form_id) {
        const newEntries = [...reviewEntries];
        newEntries.unshift(e.detail.entry);
        setReviewEntries(newEntries);
      }
    });
    return () => {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      window.removeEventListener('review_submit', () => {});
    };
  }, [form, reviewEntries]);
  return (
    <ReviewEntiresWrapper className="review-entries grid gap-3 md:grid-cols-2 xs:grid-cols-1 grid-cols-1  p-4">
      {reviewEntries.map((entry: ReviewEntry, i: number) => (
        <ReviewEntryCard entry={entry} key={i} />
      ))}
    </ReviewEntiresWrapper>
  );
};

const ReviewEntiresWrapper = styled.div`
  .review-entry {
    margin-bottom: 1rem;
  }
`;
